import React from 'react';

export default function CustomBox(props) {
    return(
        <>
            <h5 style={{margin:"10px 8px" }}>{props?.title}</h5>
            <div style={{border:".2px solid",margin:"0px 8px",padding:"0px 2px" }}>
            {props?.details}
            </div>
        </>
    )
}
